import React from 'grommet';
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  onFetchContributors,
  onFetchContributorsFailure,
  onFetchContributorsSuccess,
} from '../actions/User';
import userReducer, { IState } from '../reducers/User';
import { fetchContributorDetails } from '../services/github';
import { ContributionsColumn, NameColumn } from '../utils/userTable';

interface IContextProps {
  state: IState;
  dispatch: ({ type }: { type: string }) => void;
}

export const UserContext = createContext({} as IContextProps);

/** Initial State */
const initialState = {
  user: {},
  dataTable: {
    columns: [
      {
        property: 'name',
        header: 'Repository Name',
        primary: true,
        render: NameColumn,
      },
      {
        property: 'contributions',
        header: 'Total Contributions',
        render: ContributionsColumn,
      },
    ],
    data: [],
  },
  error: '',
  loading: false,
};

function UserProvider(props: any) {
  const [state, dispatch] = useReducer(userReducer, initialState);
  const { username }: { username: string } = useParams();
  const history = useHistory();

  const value = { state, dispatch };

  const initialLoad = useCallback(async () => {
    try {
      dispatch(onFetchContributors());
      const { repos, user } = await fetchContributorDetails(username);
      dispatch(onFetchContributorsSuccess(user, repos));
    } catch (error) {
      dispatch(onFetchContributorsFailure());
      alert('An unexpected error ocurred, try again. API Rate Limit Exceeded?');
      history.push('/');
      console.error(error);
    }
  }, [username, history]);

  useEffect(() => {
    initialLoad();
  }, [initialLoad]);

  return <UserContext.Provider value={value} {...props} />;
}

function useUserContext() {
  return useContext(UserContext);
}

export { UserProvider, useUserContext };
